import fs from 'node:fs';
import path from 'node:path';

import { CredentialFlavor } from './flavor';

const readTestDataFile = (filepath: string): Blob =>
    new Blob([fs.readFileSync(path.join(__dirname, './testdata', filepath))]);

type VcdmVersion = number;

describe('CredentialFlavor', () => {
    const flavor = new CredentialFlavor();

    describe.each<VcdmVersion>([1, 2])(`VCDM v%s`, (version) => {
        const credential = readTestDataFile(`credentials/credential-v${version}.json`);

        it('should return claims from a VC blob', async () => {
            const claims = await flavor.getClaims(credential);

            expect(claims).toEqual({
                bar: 'bar',
                baz: 'baz',
            });
        });

        it('should return metadata from blob', async () => {
            const metadata = await flavor.getMetadata(credential);

            expect(metadata).toEqual({
                id: 'did:example:123',
                subject: 'did:example:456',
                issuer: 'https://example.edu/issuers/565049',
                validFrom: version === 1 ? new Date('2024-09-13T13:10:52Z') : undefined,
            });
        });
    });

    it('should return inlined json schema', async () => {
        const credential = readTestDataFile(`credentials/credential-with-json-schema.json`);
        const schema = await flavor.getSchema(credential);

        expect(schema).toMatchObject({
            $schema: 'https://json-schema.org/draft/2020-12/schema',
            $id: 'urn:json-schema:struct',
        });
    });
});
